<div class="row">
  <div class="col-md-8 bg-login">
    <div>
      <img class="logo" alt="Pawsnme" src="./assets/images/Logo-03.png" />
    </div>
    <div class="main-p">
      <p>Let us make the world</p>
      <p>a better place for pets</p>
    </div>
    <div class="sub-p">
      <p>Looking for a cloud-based solution to manage your clinic?</p>
    </div>
    <div class="register-div">
      <button
        type="button"
        (click)="gotoRegister()"
        class="btn btn-primary-outline register"
      >
        Register Now
      </button>
    </div>
  </div>
  <div class="col-md-4">
    <div class="login">
      <p *ngIf="!showForgetPassword">Admin Login</p>
      <p *ngIf="showForgetPassword" style="font-size: smaller">
        Forgot Password
      </p>
    </div>
    <div class="container" *ngIf="!showForgetPassword">
      <div class="col-md-12">
        <input
          [(ngModel)]="emailId"
          [ngModelOptions]="{ standalone: true }"
          placeholder="Doctor's EmailId"
          class="login-input col-md-10"
          type="text"
          maxlength="50"
          value=""
        />
        <div class="underline fa fa-user-md"></div>
      </div>
      <div class="col-md-12">
        <input
          placeholder="Password"
          class="login-input col-md-10"
          type="password"
          id="inputPassword"
          #inputPassword
          [(ngModel)]="password"
          (keyup.enter)="login()"
          [ngModelOptions]="{ standalone: true }"
          minlength="6"
          maxlength="30"
        />
        <label
          for="inputPassword"
          class="fa input-icon"
          [ngClass]="{ 'fa-eye-slash': showPassword, 'fa-eye': !showPassword }"
          (click)="
            inputPassword.type =
              inputPassword.type == 'password' ? 'text' : 'password';
            showPassword = !showPassword
          "
        ></label>

        <div class="underline fa fa-key"></div>
      </div>
      <div class="col-md-12">
        <div class="col-md-7 d-inline-block">
          <label>Forgot your password? </label>
          <a class="resetLink ml-1" (click)="forgotPassword()">Reset</a>
        </div>
        <div class="d-inline-block pt-5">
          <button
            (click)="login()"
            type="button"
            class="login-button fa fa-arrow-right"
          ></button>
        </div>
      </div>
    </div>
    <div class="container" *ngIf="showForgetPassword">
      <div class="col-md-12">
        <input
          [(ngModel)]="emailIdForgetPwd"
          [ngModelOptions]="{ standalone: true }"
          placeholder="Doctor's EmailId"
          class="login-input col-md-10"
          type="text"
          value=""
        />
        <div class="underline fa fa-user-md"></div>
      </div>
      <div class="col-md-12">
        <div class="float-right mr-5 d-inline-block pt-5">
          <button
            (click)="resetPassword()"
            type="button"
            class="login-button fa fa-arrow-right"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>
